import { createStore } from 'vuex';

export default createStore({
  state: {
    loggedInUser: null,
  },
  mutations: {
    setLoggedInUser(state, userProfile) {
      state.loggedInUser = userProfile;
    },
  },
});
